
import { ButtonProps } from 'antd';
import styled from 'styled-components';
import {ThemesColors} from "../../../themes";
import {IMood} from "../../../interface";

import { Badge, Button } from 'antd';
export interface IIconButtonProps extends ButtonProps {
    hasLeftBorder?: boolean;
    hasRightBorder?: boolean;
    count?: number;
    isMood?: boolean;
    onClick?: () => void;
}



const IconButtonWrapper = styled.div<IMood>`
    height: 100%;
    .ant-badge {
        height: 100%;
    }
    color: ${({ isMood }) =>
    isMood ? ThemesColors.popoverBackground : ThemesColors.gray700};
`;
const EbuhBadge = styled(Badge)``;


const IconButtonComponent = styled(Button)<IIconButtonProps>`
    padding: 0 10px;
    margin: 0;
    height: 100%;
    border-radius: 0;
    ${({ hasLeftBorder }) => hasLeftBorder && 'border-left: 1px solid #C7C7C7;'}
    ${({ hasRightBorder }) =>
    hasRightBorder && 'border-right: 1px solid #C7C7C7;'}

    &.ant-btn.ant-btn-icon-only {
        width: auto;
        padding: 0 20px;
    }
`;


const ButtonIcon = ({ isMood=false, count = 0, ...props }: IIconButtonProps) => {
    return (
        <IconButtonWrapper isMood={isMood}>
            <EbuhBadge color="#ffb800" count={count} offset={[-15, 15]}>
                <IconButtonComponent {...props}>
                    {props.children}
                </IconButtonComponent>
            </EbuhBadge>
        </IconButtonWrapper>
    );
};

export default ButtonIcon;
